import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Typography,
  Snackbar,
  Paper,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { uploadData } from "../libs/firebase/firestore/uploadData";
import { pallete } from "../libs/pallete";

const ScheduleService = ({ clientUuid, clientName, siteUuid }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState("");
  const [timeRange, setTimeRange] = useState("");
  const [description, setDescription] = useState("");
  const [specialRequest, setSpecialRequest] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDateChange = (event) => {
    setDate(event.target.value);
  };

  const handleTimeRangeChange = (event) => {
    setTimeRange(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const handleSpecialRequestChange = (event) => {
    setSpecialRequest(event.target.value);
  };

  const handleSendRequest = () => {
    // Handle sending the request
    setOpen(false);

    let task = {
      clientUuid: clientUuid,
      clientName: clientName,
      siteUuid: siteUuid,
      description: `Schedule service for ${clientName}`,
      complete: false,
      timeDateCreated: new Date(),
      data: {
        specialRequest,
        dateRequested: date,
        timeRangeRequested: timeRange,
        description,
      },
    };

    uploadData(
      task,
      "tasks",
      () => {
        console.log("Task added");
        setSnackbarOpen(true);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const isButtonDisabled = !date || !timeRange || !description;

  return (
    <div>
      <Button
        startIcon={<CalendarMonthIcon />}
        variant="contained"
        color="secondary"
        onClick={handleOpen}
        // disabled={isButtonDisabled}
      >
        Schedule
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        style={{
          "& .MuiDialog-paper": {
            background: pallete.warm.main,
          },
        }}
      >
        <DialogTitle color="primary">Schedule Service</DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="primary" gutterBottom>
            Please fill out the form below and we will get back to you as soon
            as possible.
          </Typography>
          <Stack direction="column" spacing={2}>
            <TextField
              color="primary"
              //   label="Date"
              type="date"
              value={date}
              onChange={handleDateChange}
              fullWidth
            />
            <FormControl color="primary" fullWidth>
              <InputLabel>Time Range</InputLabel>
              <Select
                color="primary"
                value={timeRange}
                onChange={handleTimeRangeChange}
              >
                <MenuItem value="morning">Morning</MenuItem>
                <MenuItem value="midday">Midday</MenuItem>
                <MenuItem value="afternoon">Afternoon</MenuItem>
                <MenuItem value="any">Any</MenuItem>
              </Select>
            </FormControl>
            <TextField
              color="primary"
              label="Description"
              value={description}
              onChange={handleDescriptionChange}
              fullWidth
              multiline
              rows={4}
            />
            <TextField
              color="primary"
              label="Special Request"
              value={specialRequest}
              onChange={handleSpecialRequestChange}
              fullWidth
              multiline
              rows={4}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleSendRequest}
            variant="contained"
            color="primary"
            disabled={isButtonDisabled}
          >
            Send Request
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message="Request sent successfully"
        //anchor top middle
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />
    </div>
  );
};

export default ScheduleService;
